export default __webpack_public_path__ + "static/media/woodfloorafter.1a9c634a.jpg";